import { render } from "./nameInput.vue?vue&type=template&id=31656af4&scoped=true"
import script from "./nameInput.vue?vue&type=script&lang=js"
export * from "./nameInput.vue?vue&type=script&lang=js"

import "./nameInput.vue?vue&type=style&index=0&id=31656af4&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31656af4"]])

export default __exports__